export class AdditionalMedicineForPrescriptionReleaseStruct {
    public idMedicine: number;
    public idStorage: number;
    public numberOfItens: number;

    public medicineDescription: string;
    public medicineCode: string;
    public storageBatch: string;
    public locationName: string;
}